import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/*
  Generated class for the EnvironmentProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EnvironmentProvider
{
    //#region Constructor

    /**
     * Class constructor
     */
    constructor()
    {
        this.apiEndpoint = environment.apiEndpoint;
        this.environmentName = environment.environmentName;
        this.ionicEnvName = environment.ionicEnvName;
        this.production = environment.production;
        this.customerSupportEmailAddress = environment.customerSupportEmailAddress;
        this.domain = environment.domain;
        this.trackUsage = environment.trackUsage;
        this.logServerErrors = environment.logServerErrors;
        this.firebaseConfig = environment.firebaseConfig
        this.intercom = environment.intercom;
        this.appVersion = environment.appVersion;
    }

    //#endregion


    //#region Properties

    /**
     * API endpoint
     */
    public apiEndpoint: string;

    /**
     * Site endpoint
     */
    public siteEndpoint: string;

    /**
     * Environment name
     */
    public environmentName: string;

    /**
     * Environment name (ionic variant)
     */
    public ionicEnvName: string;

    /**
     * Boolean flag indicating whether the environment
     * is running a production build
     */
    public production: boolean;

    /**
     * Customer support email address
     */
    public customerSupportEmailAddress: string;

    /**
     * Domain name to which the cookies belong 
     */
    public domain: string;

    /**
     * Boolean flag indicating whether to track usage of the application
     */
    public trackUsage: boolean;

    /**
     * Boolean flag indicating whether to log errors to server (includes error screen in app)
     */
    public logServerErrors: boolean;

    /**
     * FireBase config for web
     */
    firebaseConfig:
        {
            apiKey: string;
            authDomain: string;
            databaseURL: string;
            projectId: string;
            storageBucket: string;
            messagingSenderId: string;
            appId: string;
            measurementId: string;
        };


    /**
     * Intercom App Settings
     */
    public intercom: {
        /**
         * Intercom App Id
         */
        appId: string;

        /**
         * Intercom API key for iOS devices
         */
        apiKeyiOS: string;

        /**
         * Intercom API key for Android devices
         */
        apiKeyAndroid: string;
    }


    /**
     * App version
     */
    public appVersion: string;

    //#endregion
}
